import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService implements OnDestroy {
  private loaderSubject = new BehaviorSubject<boolean>(false);
  public loader$: Observable<boolean> = this.loaderSubject.asObservable();
  private tspIdSubject = new BehaviorSubject<number>(null);
  tspId$ = this.tspIdSubject.asObservable();

  constructor() { }

  getTspId(): number {
    return this.tspIdSubject.value;
  }

  setTspId(id: number): void {
    this.tspIdSubject.next(id);
  }

  toggleLoader(isVisible: boolean = false): void {
    this.loaderSubject.next(isVisible);
  }

  ngOnDestroy(): void {
    this.loaderSubject.complete();
  }
}
